import { createServer, Model } from 'miragejs';
import { endpoints } from 'mocks/api';
import { DOMAIN, IS_DEV, MOCK_TIMING } from 'config';

export const mockServer = (environment = 'development') => {
  const server = createServer({
    environment,
    timing: MOCK_TIMING ? parseInt(MOCK_TIMING) : 400,

    models: {
      otpAttempt: Model,
    },

    routes() {
      this.logging = IS_DEV;
      const NativeXMLHttpRequest = window.XMLHttpRequest;
      // @ts-expect-error: patching a bug in pretenderjs
      window.XMLHttpRequest = function XMLHttpRequest() {
        const request = new NativeXMLHttpRequest();
        // @ts-expect-error: patching a bug in pretenderjs
        delete request.onloadend;
        return request;
      };

      this.urlPrefix = DOMAIN;

      endpoints(this);

      this.passthrough();
      this.passthrough('https://official-joke-api.appspot.com/**');
      this.passthrough('https://catfact.ninja/**');
      this.passthrough('https://sentry.io/**');
      this.passthrough('https://cdn.segment.com/**');
      this.passthrough('https://api.segment.io/**');
    },
  });

  return server;
};
